export const viewFindAccount = 6;
export const viewHouse = 7;
export const editHouse = 8;
export const viewAccounts = 9;
export const editAccount = 10;
export const viewBills = 11;
export const editBill = 12;
export const viewPayments  = 13;
export const editPayment = 14;
export const viewTransfers = 15;
export const viewDisbursements = 16;
export const viewReports = 17;
export const viewCollectionAccounts = 18;
export const editCollectionAccounts = 19;
export const viewUsers = 20;
export const editUsers = 21;
export const viewAgents = 22;
export const editAgent = 23;
export const viewGroups = 24;
export const editGroup = 25;
export const viewRoles = 26;
export const viewReconciliation = 27;
export const editReconciliation = 28;
export const viewInvoice = 29;
export const viewPaymentReceipt = 30;
export const viewComplaints = 31;
export const editComplaints = 32;
export const viewPendingAccountsApproval = 33;
export const viewDashboard = 34;
export const viewAdminPanel = 35;
export const viewTopDashboard = 36;
export const editSubscriber = 37;
export const viewSupportMenu = 38;
export const createAccount = 40;
export const pullMoney = 41;
export const createDebitNote = 42;
export const viewRevenueAssuarance = 43;
export const viewTopLevelDisbursement = 44;
export const viewAudits = 45;


